import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';
import {  
  // Calendar Availability
  getMyCalendarAvailability,
  getProviderCalendarAvailability,
  getProviderCalendarAvailabilityByType,
  createMyCalendarAvailabilityBlock,
  bulkCreateCalendarAvailability,
  updateCalendarAvailabilityBlock,
  deleteCalendarAvailabilityBlock,
  deleteProviderCalendarAvailability,
  checkCalendarAvailabilityOverlap,
  getUpcomingAvailability,
  getProviderAvailabilityStats,
  
  // Availability Checking
  checkProviderAvailability,
  getProviderAvailabilityForDateRange,
  batchCheckProviderAvailability,
  
  // Convenience Methods
  getProviderFullAvailability,
  checkBusinessHoursAvailability,
  getAvailableProviders,
} from '../../util/api';

// ================ Action types ================ //

// Calendar Availability
export const FETCH_CALENDAR_AVAILABILITY_REQUEST = 'app/ProviderAvailabilityCalendarPage/FETCH_CALENDAR_AVAILABILITY_REQUEST';
export const FETCH_CALENDAR_AVAILABILITY_SUCCESS = 'app/ProviderAvailabilityCalendarPage/FETCH_CALENDAR_AVAILABILITY_SUCCESS';
export const FETCH_CALENDAR_AVAILABILITY_ERROR = 'app/ProviderAvailabilityCalendarPage/FETCH_CALENDAR_AVAILABILITY_ERROR';

export const CREATE_CALENDAR_AVAILABILITY_REQUEST = 'app/ProviderAvailabilityCalendarPage/CREATE_CALENDAR_AVAILABILITY_REQUEST';
export const CREATE_CALENDAR_AVAILABILITY_SUCCESS = 'app/ProviderAvailabilityCalendarPage/CREATE_CALENDAR_AVAILABILITY_SUCCESS';
export const CREATE_CALENDAR_AVAILABILITY_ERROR = 'app/ProviderAvailabilityCalendarPage/CREATE_CALENDAR_AVAILABILITY_ERROR';

export const UPDATE_CALENDAR_AVAILABILITY_REQUEST = 'app/ProviderAvailabilityCalendarPage/UPDATE_CALENDAR_AVAILABILITY_REQUEST';
export const UPDATE_CALENDAR_AVAILABILITY_SUCCESS = 'app/ProviderAvailabilityCalendarPage/UPDATE_CALENDAR_AVAILABILITY_SUCCESS';
export const UPDATE_CALENDAR_AVAILABILITY_ERROR = 'app/ProviderAvailabilityCalendarPage/UPDATE_CALENDAR_AVAILABILITY_ERROR';

export const DELETE_CALENDAR_AVAILABILITY_REQUEST = 'app/ProviderAvailabilityCalendarPage/DELETE_CALENDAR_AVAILABILITY_REQUEST';
export const DELETE_CALENDAR_AVAILABILITY_SUCCESS = 'app/ProviderAvailabilityCalendarPage/DELETE_CALENDAR_AVAILABILITY_SUCCESS';
export const DELETE_CALENDAR_AVAILABILITY_ERROR = 'app/ProviderAvailabilityCalendarPage/DELETE_CALENDAR_AVAILABILITY_ERROR';

// Availability Checking
export const CHECK_AVAILABILITY_REQUEST = 'app/ProviderAvailabilityCalendarPage/CHECK_AVAILABILITY_REQUEST';
export const CHECK_AVAILABILITY_SUCCESS = 'app/ProviderAvailabilityCalendarPage/CHECK_AVAILABILITY_SUCCESS';
export const CHECK_AVAILABILITY_ERROR = 'app/ProviderAvailabilityCalendarPage/CHECK_AVAILABILITY_ERROR';

export const BATCH_CHECK_AVAILABILITY_REQUEST = 'app/ProviderAvailabilityCalendarPage/BATCH_CHECK_AVAILABILITY_REQUEST';
export const BATCH_CHECK_AVAILABILITY_SUCCESS = 'app/ProviderAvailabilityCalendarPage/BATCH_CHECK_AVAILABILITY_SUCCESS';
export const BATCH_CHECK_AVAILABILITY_ERROR = 'app/ProviderAvailabilityCalendarPage/BATCH_CHECK_AVAILABILITY_ERROR';

export const GET_AVAILABILITY_STATS_REQUEST = 'app/ProviderAvailabilityCalendarPage/GET_AVAILABILITY_STATS_REQUEST';
export const GET_AVAILABILITY_STATS_SUCCESS = 'app/ProviderAvailabilityCalendarPage/GET_AVAILABILITY_STATS_SUCCESS';
export const GET_AVAILABILITY_STATS_ERROR = 'app/ProviderAvailabilityCalendarPage/GET_AVAILABILITY_STATS_ERROR';

// ================ Reducer ================ //

const initialState = {
  // Calendar Availability
  fetchCalendarAvailabilityInProgress: false,
  fetchCalendarAvailabilityError: null,
  createCalendarAvailabilityInProgress: false,
  createCalendarAvailabilityError: null,
  updateCalendarAvailabilityInProgress: false,
  updateCalendarAvailabilityError: null,
  deleteCalendarAvailabilityInProgress: false,
  deleteCalendarAvailabilityError: null,
  
  // Availability Checking
  checkAvailabilityInProgress: false,
  checkAvailabilityError: null,
  batchCheckAvailabilityInProgress: false,
  batchCheckAvailabilityError: null,
  getAvailabilityStatsInProgress: false,
  getAvailabilityStatsError: null,
  
  // Data
  calendarAvailability: null,
  availabilityCheck: null,
  batchAvailabilityCheck: null,
  availabilityStats: null,
  pagination: null,
};

export default function providerAvailabilityPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  
  switch (type) {
    // Calendar Availability
    case FETCH_CALENDAR_AVAILABILITY_REQUEST:
      return { ...state, fetchCalendarAvailabilityInProgress: true, fetchCalendarAvailabilityError: null };
    case FETCH_CALENDAR_AVAILABILITY_SUCCESS:
      return {
        ...state,
        fetchCalendarAvailabilityInProgress: false,
        calendarAvailability: payload.data,
        pagination: payload.meta,
      };
    case FETCH_CALENDAR_AVAILABILITY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchCalendarAvailabilityInProgress: false, fetchCalendarAvailabilityError: payload };

    case CREATE_CALENDAR_AVAILABILITY_REQUEST:
      return { ...state, createCalendarAvailabilityInProgress: true, createCalendarAvailabilityError: null };
    case CREATE_CALENDAR_AVAILABILITY_SUCCESS:
      return {
        ...state,
        createCalendarAvailabilityInProgress: false,
        pagination: payload.meta,
      };
    case CREATE_CALENDAR_AVAILABILITY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, createCalendarAvailabilityInProgress: false, createCalendarAvailabilityError: payload };

    case UPDATE_CALENDAR_AVAILABILITY_REQUEST:
      return { ...state, updateCalendarAvailabilityInProgress: true, updateCalendarAvailabilityError: null };
    case UPDATE_CALENDAR_AVAILABILITY_SUCCESS:
      return {
        ...state,
        updateCalendarAvailabilityInProgress: false,
        pagination: payload.meta,
      };
    case UPDATE_CALENDAR_AVAILABILITY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, updateCalendarAvailabilityInProgress: false, updateCalendarAvailabilityError: payload };

    case DELETE_CALENDAR_AVAILABILITY_REQUEST:
      return { ...state, deleteCalendarAvailabilityInProgress: true, deleteCalendarAvailabilityError: null };
    case DELETE_CALENDAR_AVAILABILITY_SUCCESS:
      return {
        ...state,
        deleteCalendarAvailabilityInProgress: false,
        pagination: payload.meta,
      };
    case DELETE_CALENDAR_AVAILABILITY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, deleteCalendarAvailabilityInProgress: false, deleteCalendarAvailabilityError: payload };

    // Availability Checking
    case CHECK_AVAILABILITY_REQUEST:
      return { ...state, checkAvailabilityInProgress: true, checkAvailabilityError: null };
    case CHECK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        checkAvailabilityInProgress: false,
        availabilityCheck: payload.data,
        pagination: payload.meta,
      };
    case CHECK_AVAILABILITY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, checkAvailabilityInProgress: false, checkAvailabilityError: payload };

    case BATCH_CHECK_AVAILABILITY_REQUEST:
      return { ...state, batchCheckAvailabilityInProgress: true, batchCheckAvailabilityError: null };
    case BATCH_CHECK_AVAILABILITY_SUCCESS:
      return {
        ...state,
        batchCheckAvailabilityInProgress: false,
        batchAvailabilityCheck: payload.data,
        pagination: payload.meta,
      };
    case BATCH_CHECK_AVAILABILITY_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, batchCheckAvailabilityInProgress: false, batchCheckAvailabilityError: payload };

    case GET_AVAILABILITY_STATS_REQUEST:
      return { ...state, getAvailabilityStatsInProgress: true, getAvailabilityStatsError: null };
    case GET_AVAILABILITY_STATS_SUCCESS:
      return {
        ...state,
        getAvailabilityStatsInProgress: false,
        availabilityStats: payload.data,
        pagination: payload.meta,
      };
    case GET_AVAILABILITY_STATS_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, getAvailabilityStatsInProgress: false, getAvailabilityStatsError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

// Calendar Availability
const fetchCalendarAvailabilityRequest = () => ({ type: FETCH_CALENDAR_AVAILABILITY_REQUEST });
const fetchCalendarAvailabilitySuccess = response => ({
  type: FETCH_CALENDAR_AVAILABILITY_SUCCESS,
  payload: response,
});
const fetchCalendarAvailabilityError = e => ({
  type: FETCH_CALENDAR_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

const createCalendarAvailabilityRequest = () => ({ type: CREATE_CALENDAR_AVAILABILITY_REQUEST });
const createCalendarAvailabilitySuccess = response => ({
  type: CREATE_CALENDAR_AVAILABILITY_SUCCESS,
  payload: response,
});
const createCalendarAvailabilityError = e => ({
  type: CREATE_CALENDAR_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

const updateCalendarAvailabilityRequest = () => ({ type: UPDATE_CALENDAR_AVAILABILITY_REQUEST });
const updateCalendarAvailabilitySuccess = response => ({
  type: UPDATE_CALENDAR_AVAILABILITY_SUCCESS,
  payload: response,
});
const updateCalendarAvailabilityError = e => ({
  type: UPDATE_CALENDAR_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

const deleteCalendarAvailabilityRequest = () => ({ type: DELETE_CALENDAR_AVAILABILITY_REQUEST });
const deleteCalendarAvailabilitySuccess = response => ({
  type: DELETE_CALENDAR_AVAILABILITY_SUCCESS,
  payload: response,
});
const deleteCalendarAvailabilityError = e => ({
  type: DELETE_CALENDAR_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

// Availability Checking
const checkAvailabilityRequest = () => ({ type: CHECK_AVAILABILITY_REQUEST });
const checkAvailabilitySuccess = response => ({
  type: CHECK_AVAILABILITY_SUCCESS,
  payload: response,
});
const checkAvailabilityError = e => ({
  type: CHECK_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

const batchCheckAvailabilityRequest = () => ({ type: BATCH_CHECK_AVAILABILITY_REQUEST });
const batchCheckAvailabilitySuccess = response => ({
  type: BATCH_CHECK_AVAILABILITY_SUCCESS,
  payload: response,
});
const batchCheckAvailabilityError = e => ({
  type: BATCH_CHECK_AVAILABILITY_ERROR,
  error: true,
  payload: e,
});

const getAvailabilityStatsRequest = () => ({ type: GET_AVAILABILITY_STATS_REQUEST });
const getAvailabilityStatsSuccess = response => ({
  type: GET_AVAILABILITY_STATS_SUCCESS,
  payload: response,
});
const getAvailabilityStatsError = e => ({
  type: GET_AVAILABILITY_STATS_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

const PAGE_SIZE = 20;

export const fetchCalendarAvailability = (startDate, endDate) => (dispatch, getState, sdk) => {
  dispatch(fetchCalendarAvailabilityRequest());

  return getMyCalendarAvailability(startDate, endDate)
    .then(response => {
      const transformedData = {
        total_items: response?.total_items || 0,
        items: Array.isArray(response?.items) ? response.items.map(mi => ({
          ...mi,
          start: mi.start_datetime,
          end: mi.end_datetime,
          type: mi.availability_type,
          description: mi.reason,
        })) : [],
      };
      dispatch(fetchCalendarAvailabilitySuccess({ data: transformedData }));
      return response;
    })
    .catch(e => {
      dispatch(fetchCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

export const createCalendarAvailabilityEvent = (params) => (dispatch, getState, sdk) => {
  dispatch(createCalendarAvailabilityRequest());

  return createMyCalendarAvailabilityBlock(params)
    .then(response => {
      dispatch(createCalendarAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(createCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

export const updateCalendarAvailabilityEvent = (blockId, params) => (dispatch, getState, sdk) => {
  dispatch(updateCalendarAvailabilityRequest());

  return updateCalendarAvailabilityBlock(blockId, params)
    .then(response => {
      dispatch(updateCalendarAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(updateCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

export const deleteCalendarAvailabilityEvent = (blockId) => (dispatch, getState, sdk) => {
  dispatch(deleteCalendarAvailabilityRequest());

  return deleteCalendarAvailabilityBlock(blockId)
    .then(response => {
      dispatch(deleteCalendarAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(deleteCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

export const checkProviderAvailabilityAction = (providerId, startDatetime, endDatetime) => (dispatch, getState, sdk) => {
  dispatch(checkAvailabilityRequest());

  return checkProviderAvailability(providerId, startDatetime, endDatetime)
    .then(response => {
      dispatch(checkAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(checkAvailabilityError(storableError(e)));
      throw e;
    });
};

export const doBatchCheckProviderAvailability = (providerIds, startDatetime, endDatetime) => (dispatch, getState, sdk) => {
  dispatch(batchCheckAvailabilityRequest());

  return batchCheckProviderAvailability(providerIds, startDatetime, endDatetime)
    .then(response => {
      dispatch(batchCheckAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(batchCheckAvailabilityError(storableError(e)));
      throw e;
    });
};

export const checkDateRangeAvailability = (providerId, startDate, endDate, timeSlots) => (dispatch, getState, sdk) => {
  dispatch(checkAvailabilityRequest());

  return getProviderAvailabilityForDateRange(providerId, startDate, endDate, timeSlots)
    .then(response => {
      dispatch(checkAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(checkAvailabilityError(storableError(e)));
      throw e;
    });
};

export const getProviderStats = (providerId, startDate, endDate) => (dispatch, getState, sdk) => {
  dispatch(getAvailabilityStatsRequest());

  return getProviderAvailabilityStats(providerId, startDate, endDate)
    .then(response => {
      dispatch(getAvailabilityStatsSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(getAvailabilityStatsError(storableError(e)));
      throw e;
    });
};

export const getProviderUpcomingAvailability = (providerId, daysAhead = 30) => (dispatch, getState, sdk) => {
  dispatch(fetchCalendarAvailabilityRequest());

  return getUpcomingAvailability(providerId, daysAhead)
    .then(response => {
      dispatch(fetchCalendarAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

export const checkWeeklyConflict = (providerId, params) => (dispatch, getState, sdk) => {
  return checkWeeklyTimeConflict(providerId, params)
    .then(response => {
      return response;
    })
    .catch(e => {
      throw e;
    });
};

export const checkCalendarOverlap = (providerId, params) => (dispatch, getState, sdk) => {
  return checkCalendarAvailabilityOverlap(providerId, params)
    .then(response => {
      return response;
    })
    .catch(e => {
      throw e;
    });
};

export const getFullProviderAvailability = (providerId, startDate, endDate) => (dispatch, getState, sdk) => {
  dispatch(fetchWeeklyScheduleRequest());
  dispatch(fetchCalendarAvailabilityRequest());

  return getProviderFullAvailability(providerId, startDate, endDate)
    .then(response => {
      dispatch(fetchWeeklyScheduleSuccess({ data: response.weekly_schedule }));
      dispatch(fetchCalendarAvailabilitySuccess({ data: response.calendar_availability }));
      return response;
    })
    .catch(e => {
      dispatch(fetchWeeklyScheduleError(storableError(e)));
      dispatch(fetchCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

export const findAvailableProviders = (providerIds, startDatetime, endDatetime) => (dispatch, getState, sdk) => {
  dispatch(batchCheckAvailabilityRequest());

  return getAvailableProviders(providerIds, startDatetime, endDatetime)
    .then(response => {
      dispatch(batchCheckAvailabilitySuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(batchCheckAvailabilityError(storableError(e)));
      throw e;
    });
};

export const loadData = (params, search) => dispatch => {
  dispatch(fetchCalendarAvailabilityRequest());
  const { startDate, endDate } = params || {};

  return getMyCalendarAvailability(startDate, endDate)
    .then((response) => {
      const transformedData = {
        total_items: response?.total_items || 0,
        items: Array.isArray(response?.items) ? response.items.map(mi => ({
          ...mi,
          start: mi.start_datetime,
          end: mi.end_datetime,
          type: mi.availability_type,
          description: mi.reason,
        })) : [],
      };
      dispatch(fetchCalendarAvailabilitySuccess({ data: transformedData }));
      return response;
    })
    .catch(e => {
      dispatch(fetchCalendarAvailabilityError(storableError(e)));
      throw e;
    });
};

// Fetch calendar availability by provider id
export const fetchCalendarAvailabilityByProviderId = (userId, startDate, endDate) => async (dispatch, getState, sdk) => {
  try {
    // 2. Fetch calendar availability using internal provider_id
    const response = await getProviderCalendarAvailability(userId, startDate, endDate);
    const transformedData = {
      total_items: response?.total_items || 0,
      items: Array.isArray(response?.items) ? response.items.map(mi => ({
        ...mi,
        start: mi.start_datetime,
        end: mi.end_datetime,
        type: mi.availability_type,
        description: mi.reason,
      })) : [],
    };
    return transformedData;
  } catch (e) {
    dispatch(fetchCalendarAvailabilityError(storableError(e)));
    throw e;
  }
};